import React from 'react';
import './index.css';
function Navbar() {

  return (
    <div style={{backgroundColor: '#ffffff'}}>
    <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', textAlign: 'center', fontFamily: "'Poppins', sans-serif", color:'#ea0e2c'}}>
        <h1 style={{fontSize: '8vw'}}>¡UNA DISCULPA!</h1>
        <h1 style={{fontSize: '8vw'}}>PÁGINA NO ENCONTRADA</h1>
    </div>
    </div>);
}
export default Navbar;